import ImageCdn from '@/components/common/ImageCdn'

class VueImageComponent {
  /**
   * component 安装
   * @param Vue
   * @param config
   * @returns {Promise<void>}
   */
  async install (Vue, config) {
    Vue.component('image-cdn', ImageCdn)

    // 全站使用 cdn
    const cdn = window.isCdnSupport = window.yunweiConfig.imageServer
    // Vue.provide('$cdn', cdn)
    Vue.config.globalProperties.$cdn = window.isCdnSupport = window.yunweiConfig.imageServer
  }
}

export default new VueImageComponent()
